var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("In the future, we will update the results of the experiment verification on this page!")])])
}]

export { render, staticRenderFns }